import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'

class OAuthLanding extends Component {

  closeWindow() {
    window.ww = window.open(window.location, '_self').close()
  }
  
  render() {
    const { name } = this.props.appInfo
    return (
      <div className="drift-oauth-landing">
        <h2>{ name } would like to access Drift</h2>
        <div className="drift-oauth-landing-wrapper">
          <ul>
            <li> <strong>{name} will be able to do everything that Drift can do</strong></li>
            <li>Live Chat With Your Customers</li>
            <li>Send Customers In-App Messages</li>
            <li>Improve your net promoter-score… and more!</li>
          </ul>
        </div>

        <div className="oauth-actions">
          <button className="drift-button drift-button-primary large" onClick={this.props.redirectWithCode}>Authorize</button>
          <button className="drift-button large" onClick={this.closeWindow}>Cancel</button>
        </div>
      </div>
    )
  }
}

const OAuthLandingPage = withRouter(OAuthLanding)

export default OAuthLandingPage



// WEBPACK FOOTER //
// ./src/components/pages/OAuthLanding/index.js